var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WarningCircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.09375C5.73807 3.09375 3.09375 5.73807 3.09375 9C3.09375 12.2619 5.73807 14.9062 9 14.9062C12.2619 14.9062 14.9062 12.2619 14.9062 9C14.9062 5.73807 12.2619 3.09375 9 3.09375ZM1.40625 9C1.40625 4.80609 4.80609 1.40625 9 1.40625C13.1939 1.40625 16.5938 4.80609 16.5938 9C16.5938 13.1939 13.1939 16.5938 9 16.5938C4.80609 16.5938 1.40625 13.1939 1.40625 9Z",
    fill: "#FAAD14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.78125C9.46599 4.78125 9.84375 5.15901 9.84375 5.625V9.28125C9.84375 9.74724 9.46599 10.125 9 10.125C8.53401 10.125 8.15625 9.74724 8.15625 9.28125V5.625C8.15625 5.15901 8.53401 4.78125 9 4.78125Z",
    fill: "#FAAD14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 13.2188C9.62132 13.2188 10.125 12.7151 10.125 12.0938C10.125 11.4724 9.62132 10.9688 9 10.9688C8.37868 10.9688 7.875 11.4724 7.875 12.0938C7.875 12.7151 8.37868 13.2188 9 13.2188Z",
    fill: "#FAAD14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.d49db8e6.svg";
export { ForwardRef as ReactComponent };